type FindingColorBoxProps = {
  color: string;
  isDotted?: boolean;
};

export const FindingColorBox = ({
  color,
  isDotted = false,
}: FindingColorBoxProps) => (
  <div
    className={`vai-w-4 vai-h-4 vai-border-2 ${
      isDotted ? 'vai-border-dotted' : 'vai-border-solid'
    }`}
    style={{ borderColor: color }}
  />
);
